<!-- 限销商品操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
            :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index == 0">
                <!-- 主要信息 -->
                <el-form :model="addForm" id="mainInfo" :inline="true" ref="sendDataInfo" size="mini" label-width="80px">
                  <el-form-item>
                    <el-button style="margin-left: 20px;" type="primary" size="mini"
                      @click="openSearch('853533363572736')">
                      选择商品
                    </el-button>
                    <el-button style="margin-left: 20px;" type="primary" size="mini" @click="delGoods">
                      删除商品
                    </el-button>
                  </el-form-item>

                </el-form>
                <el-table border :data="goodsData" style="width: 100%" :height="mxHeight">
                  <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                      <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                        <i class="el-icon-thumb"></i>
                      </el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column prop="bgmName" label="商品名称" min-width="100">
                </el-table-column>
                <el-table-column prop="spec" label="规格" min-width="180">
                </el-table-column>
                <el-table-column prop="bgiPerholder" label="产地" min-width="180">
                </el-table-column>
                <el-table-column prop="manufacturer" label="生产厂商" min-width="180">
                </el-table-column>
                <el-table-column prop="num" label="最小数量" min-width="80">
                <template slot-scope="scope">
                    <el-input type="number" v-model.number="goodsData[scope.$index].num"  @input="handleInputNum(scope.$index,$event)"  ></el-input>
                </template>
                </el-table-column>
                <el-table-column prop="multiple" label="倍数" min-width="80">
                    <template slot-scope="scope">
                    <el-input type="number" v-model.number="goodsData[scope.$index].multiple" @input="handleInput(scope.$index,$event)"></el-input>
                </template>
                </el-table-column>
                </el-table>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div style="text-align:center;" class="foot">
          <el-button v-if="dataActionBox.actionType != 2" type="primary"
            @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 1">保存</el-button>
        </div>

      </div>
    </div>
    <el-dialog :modal-append-to-body='true' :append-to-body="true" :title="seTitle" v-if="DialogVisible"
      :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="SearchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
        @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
  name: "desuLimitbs",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      parentSearchData: {},
      seId: 0,
      cmId: 0,
      selectedDataIndex: 0,
      sendDataInfo: {
        isEnable: 1,
        glcDesc: '',
        classifyName: ''
      },
      goodsData: [],
      addForm: {
        glcId: ''
      },
      tabForm: [],
      showTabs: "",
      DialogVisible: false, //检索
      seId: "",
      seWidth: "",
      seTitle: "",
      seType: "",
      isLoaded: false,
      options: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    handleInputNum(index,e){
            let value=e
             if(value<0){
                value=1
             }
             this.goodsData[index].num=Number(value)
        },
        handleInput(index,e){
            let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
            value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
             if(value==0){
                value=''
             }
             this.goodsData[index].multiple=value
        },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
    },
    delGoods() {
      if (this.goodsData.length > 0) {
        this.goodsData.splice(this.selectedDataIndex, 1)
      } else {
        this.$message.error('暂无可删除的数据')
      }
    },
    //提取返回
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.goodsData.findIndex(item => item.bgmId == val.bgmId) == -1) {
          this.goodsData.push(val)
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          // console.log('sendDataInfo', this.sendDataInfo)
          this.sub();
        } else {
          this.$message({
            message: "请完善必填信息",
            type: "error",
          });
          return false;
        }
      });
    },
    searchDataList() {
      this.$http.queryClassifyData({ classifyName: '' }).then(res => {
        if (res.status == 200) {
          this.options = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    async sub() {
      var responseData;
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.addGoodsMultipleData(this.goodsData.map(item => {
                    return {
                        bgmId:item.bgmId,
                        multiple:Number(item.multiple),
                        num:Number(item.num),
                    }
         }))
      } else if (this.dataActionBox.actionType == 1) {
        responseData = await this.$http.updateClassifyData(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
        // this.dataActionBox.showStatus = false
        // this.$parent.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消
    initActionBox(formName1) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消新增限销倍数吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel");
          // this.$parent.getDataList()
          this.init();
          this.$refs[formName1].resetFields();
        })
        .catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "scopeType") {
          this.sendDataInfo[key] = 0;
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    //父级传入
    openBox(cate, formData, oldData = "") {
      this.showTabs = this.dataActionBox.boxTitle + '限销倍数'
      this.filterMainField()
      this.init();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 16.7)
      });
    },
    // 过滤表单不同类型
    filterMainField() {
      this.tabForm = [
        {
          jciName: this.dataActionBox.boxTitle + '限销倍数',
          jurconfigform: []
        }
      ]
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.searchDataList()

      var params = this.actionData;
      this.openBox(params.cate, params.formData, params.oldData);
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
